import { TCALCULATOR_FIELD_TYPE } from '../types';
import {
  CALCULATOR_THEMES,
  ICalculatorTheme,
} from '../types/calculator-themes';

/**
 * Detects the appropriate calculator theme based on field keys
 * @param fields - Calculator fields object
 * @returns Theme ID string
 */
const detectCalculatorTheme = (fields: TCALCULATOR_FIELD_TYPE): string => {
  const fieldKeys = Object.keys(fields);

  // GST Calculator detection - check for GST-specific output fields
  if (fieldKeys.some((key) => ['CGST', 'SGST', 'IGST'].includes(key))) {
    return 'gst';
  }

  // Future: Add more theme detections here

  return 'default';
};

/**
 * Gets the calculator theme configuration
 * @param fields - Calculator fields object
 * @returns Calculator theme configuration
 */
export const getCalculatorTheme = (
  fields: TCALCULATOR_FIELD_TYPE
): ICalculatorTheme => {
  const themeId = detectCalculatorTheme(fields);
  return CALCULATOR_THEMES[themeId] ?? CALCULATOR_THEMES.default!;
};

/**
 * Checks if calculator is of a specific theme type
 * @param fields - Calculator fields object
 * @param themeId - Theme ID to check against
 * @returns Boolean indicating if calculator matches the theme
 */
const isCalculatorTheme = (
  fields: TCALCULATOR_FIELD_TYPE,
  themeId: string
): boolean => {
  return detectCalculatorTheme(fields) === themeId;
};
